import React from 'react'
import {useIntl} from 'react-intl'

// Components
import StoreLocatorContent from '../../components/store-locator/index'
import Seo from '../../components/seo'

/* Providers */
import {StoreLocatorProvider} from '../../contexts/store-locator-context'
import {APIProvider} from '@vis.gl/react-google-maps'

/* Configs */
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import useCanonicalUrl from '../../hooks/use-canonical-url'
import {getSeoBrandName} from '../../utils/seo'

const StoreLocator = () => {
    /* Configs */
    const config = getConfig()
    const GOOGLE_MAPS_API_KEY = config.app.GOOGLE_MAPS_API_KEY || null
    const {formatMessage} = useIntl()
    const {locale} = useMultiSite()
    const canonicalUrl = useCanonicalUrl()
    const seoBrandName = getSeoBrandName(Boolean(locale?.isSupportedByESW))
    const pageTitle = formatMessage(
        {
            id: 'store_locator.page.title',
            defaultMessage: 'Find a Store | {seoBrandName}'
        },
        {seoBrandName}
    )
    const pageDescription = formatMessage(
        {
            id: 'store_locator.page.description',
            defaultMessage: 'Find a Store | {seoBrandName}'
        },
        {seoBrandName}
    )

    return (
        <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
            <Seo title={pageTitle} description={pageDescription} canonicalUrl={canonicalUrl}>
                <link rel="canonical" href={canonicalUrl} />
            </Seo>
            <StoreLocatorProvider>
                <StoreLocatorContent />
            </StoreLocatorProvider>
        </APIProvider>
    )
}

StoreLocator.getTemplateName = () => 'store-locator'

export default StoreLocator
